import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinmumbai() {



    const cardData = {

keyword: "Swift Dzire on Rent in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers affordable and reliable Swift Dzire on Rent in Mumbai for local travel, airport transfers, corporate trips, and outstation journeys. The Swift Dzire is a comfortable and fuel-efficient sedan ideal for small families, business travel, and daily commuting. We provide well-maintained vehicles with professional and verified chauffeurs, ensuring safe, smooth, and on-time travel across Mumbai. With 24x7 availability, doorstep pickup and drop, transparent pricing, and flexible rental options, we make your journey comfortable and budget-friendly.",

topPlaces: [
    {
        title: "Mumbai Airport Transfers",
        description:
            "Swift Dzire is one of the most preferred cars for Mumbai Airport pickup and drop due to its comfort, affordability, and smooth ride quality. It is ideal for solo travelers and small families traveling to and from domestic and international terminals."
    },
    {
        title: "Local Mumbai City Travel",
        description:
            "The Swift Dzire is perfect for daily local travel in Mumbai including office commutes, shopping trips, hospital visits, and business meetings with comfortable seating and efficient fuel economy."
    },
    {
        title: "Pune Outstation Travel",
        description:
            "Swift Dzire is widely used for Mumbai to Pune travel due to its smooth highway performance, comfort, and cost-effectiveness, making it ideal for one-way and round trips."
    },
    {
        title: "Lonavala & Khandala Trips",
        description:
            "This sedan is a great choice for short weekend trips to Lonavala and Khandala, offering a comfortable ride for couples and small families enjoying scenic hill station travel."
    },
    {
        title: "Nashik & Shirdi Pilgrimage Trips",
        description:
            "Swift Dzire is commonly booked for spiritual journeys to Nashik and Shirdi, providing a comfortable and budget-friendly option for temple visits and religious travel."
    },
    {
        title: "Business & Corporate Travel",
        description:
            "Ideal for corporate employees and professionals, Swift Dzire offers a clean, comfortable, and professional travel experience for meetings, office visits, and client transportation."
    },
    {
        title: "Weekend Getaways",
        description:
            "Swift Dzire is suitable for short weekend trips from Mumbai to nearby destinations like Alibaug, Igatpuri, and Matheran with smooth and relaxed travel experience."
    },
    {
        title: "Family Travel Rides",
        description:
            "With comfortable seating and sufficient luggage space, Swift Dzire is ideal for small family outings, city tours, and intercity travel from Mumbai."
    },
    {
        title: "Affordable Rental Option",
        description:
            "Swift Dzire is one of the most budget-friendly sedan options in Mumbai, offering low rental cost without compromising comfort and safety for all types of travel."
    },
    {
        title: "24x7 Booking Availability",
        description:
            "Customers can book Swift Dzire anytime with instant confirmation, quick driver assignment, and round-the-clock support for local and outstation travel needs."
    }
],



services: [
{
name: "Swift Dzire on Rent in Mumbai",
description: "Mumbai Airport Cab offers Swift Dzire on Rent in Mumbai with fully maintained AC sedan cars, ideal for comfortable city travel, airport transfers, family trips, and outstation journeys. Our service includes professional chauffeurs, doorstep pickup, transparent pricing, and 24x7 availability for smooth and reliable travel experience."
},
{
name: "Mumbai Swift Dzire Rental",
description: "Mumbai Airport Cab provides Mumbai Swift Dzire Rental service with clean and well-maintained sedan cars suitable for local travel, airport pickup, and long-distance journeys. We ensure safe driving, affordable pricing, and timely service for all passengers."
},
{
name: "Swift Dzire Cab Mumbai",
description: "Swift Dzire Cab Mumbai service offers comfortable AC sedan rides with experienced drivers for city travel, office commute, and airport transfers. Our focus is on safety, punctuality, and smooth travel experience."
},
{
name: "Rent Swift Dzire Mumbai",
description: "Rent Swift Dzire Mumbai service allows easy booking of chauffeur-driven Dzire cars for personal, family, and business travel. We provide flexible booking options and reliable transportation across Mumbai."
},
{
name: "Swift Dzire Taxi Mumbai",
description: "Swift Dzire Taxi Mumbai ensures safe and affordable travel with clean vehicles and professional chauffeurs for daily commuting, airport drops, and intercity travel."
},
{
name: "Dzire Car Hire Mumbai",
description: "Dzire Car Hire Mumbai service provides budget-friendly sedan rentals with comfortable seating, experienced drivers, and smooth travel for short and long-distance trips."
},
{
name: "Swift Dzire Outstation Cab Mumbai",
description: "Swift Dzire Outstation Cab Mumbai offers reliable long-distance travel to destinations like Pune, Nashik, Shirdi, and Goa with safe driving and comfortable AC sedans."
},
{
name: "Swift Dzire Airport Cab Mumbai",
description: "Swift Dzire Airport Cab Mumbai provides timely pickup and drop services from Mumbai Airport with flight tracking, luggage support, and professional chauffeurs for hassle-free travel."
},
{
name: "Swift Dzire Family Cab Mumbai",
description: "Swift Dzire Family Cab Mumbai is designed for small family trips with comfortable seating, smooth rides, and affordable pricing for weekend and holiday travel."
},
{
name: "Swift Dzire Budget Cab Mumbai",
description: "Swift Dzire Budget Cab Mumbai offers economical travel solutions with clean vehicles, professional drivers, and affordable fares for daily transportation needs."
},
{
name: "Swift Dzire One Way Cab Mumbai",
description: "Swift Dzire One Way Cab Mumbai provides cost-effective single journey travel with transparent pricing and comfortable AC sedan service for long and short routes."
},
{
name: "Swift Dzire Round Trip Mumbai",
description: "Swift Dzire Round Trip Mumbai service offers return journey bookings with flexible timing, reliable chauffeurs, and smooth travel experience for all destinations."
},
{
name: "Swift Dzire Chauffeur Mumbai",
description: "Swift Dzire Chauffeur Mumbai provides professional driver service with trained chauffeurs ensuring safe driving, punctuality, and comfortable travel experience."
},
{
name: "Swift Dzire City Ride Mumbai",
description: "Swift Dzire City Ride Mumbai offers convenient intra-city travel for office, shopping, and daily commuting with clean sedans and quick availability."
},
{
name: "Swift Dzire Long Distance Mumbai",
description: "Swift Dzire Long Distance Mumbai service provides comfortable intercity travel with experienced drivers and well-maintained vehicles for safe long trips."
},
{
name: "Swift Dzire Business Cab Mumbai",
description: "Swift Dzire Business Cab Mumbai is ideal for corporate travel, meetings, and office commutes with punctual service and professional chauffeurs."
},
{
name: "Swift Dzire Tour Cab Mumbai",
description: "Swift Dzire Tour Cab Mumbai offers sightseeing and holiday travel with flexible packages and comfortable sedan rides for family and group tours."
},
{
name: "Swift Dzire Affordable Cab Mumbai",
description: "Swift Dzire Affordable Cab Mumbai ensures budget-friendly travel with reliable service, clean vehicles, and professional drivers for everyday use."
},
{
name: "Swift Dzire Travel Service Mumbai",
description: "Swift Dzire Travel Service Mumbai provides complete travel solutions for personal, business, and family needs with safe and comfortable sedan rides."
},
{
name: "Swift Dzire Daily Hire Mumbai",
description: "Swift Dzire Daily Hire Mumbai offers daily rental options for local commuting, office travel, and errands with flexible booking and dependable service."
}
],

tableData: [
["Swift Dzire on Rent in Mumbai","Mumbai Swift Dzire Rental"],
["Swift Dzire Cab Mumbai","Rent Swift Dzire Mumbai"],
["Swift Dzire Taxi Mumbai","Dzire Car Hire Mumbai"],
["Swift Dzire Outstation Cab Mumbai","Swift Dzire Airport Cab Mumbai"],
["Swift Dzire Family Cab Mumbai","Swift Dzire Budget Cab Mumbai"],
["Swift Dzire One Way Cab Mumbai","Swift Dzire Round Trip Mumbai"],
["Swift Dzire Chauffeur Mumbai","Swift Dzire City Ride Mumbai"],
["Swift Dzire Long Distance Mumbai","Swift Dzire Business Cab Mumbai"],
["Swift Dzire Tour Cab Mumbai","Swift Dzire Affordable Cab Mumbai"],
["Swift Dzire Travel Service Mumbai","Swift Dzire Daily Hire Mumbai"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Swift Dzire on Rent in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Swift Dzire on Rent in Mumbai for airport transfers, local travel, corporate transportation, outstation trips, and daily commuting requirements."
    },
    {
        WhyChooseheading: "Comfortable Sedan for Every Journey",
        WhyChoosedescription: "Swift Dzire is one of the most preferred sedan cars for comfortable travel, offering spacious seating, smooth performance, and excellent ride quality."
    },
    {
        WhyChooseheading: "Ideal for Business and Personal Travel",
        WhyChoosedescription: "Whether you are attending meetings, visiting clients, traveling with family, or planning an outstation trip, Swift Dzire offers a practical travel solution."
    },
    {
        WhyChooseheading: "Affordable and Convenient Transportation",
        WhyChoosedescription: "Swift Dzire combines comfort, efficiency, and affordability, making it a popular choice for both local and outstation travel."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Service Available",
        WhyChoosedescription: "Customers can book Swift Dzire for seamless airport transfers to and from Mumbai Airport with professional chauffeur services."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Our Swift Dzire rental service is available for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, and Goa."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, and a comfortable travel experience throughout your journey."
    },
    {
        WhyChooseheading: "Perfect for Families and Corporate Travelers",
        WhyChoosedescription: "Swift Dzire is suitable for small families, business executives, airport travelers, and tourists looking for a comfortable sedan experience."
    }
]
};

const faqData = [
    {
        question: "Why choose Swift Dzire on Rent in Mumbai?",
        answer: "Swift Dzire offers comfortable seating, smooth performance, fuel efficiency, and affordability, making it one of the most popular rental sedan cars."
    },
    {
        question: "Can I book a Swift Dzire for Mumbai Airport transfers?",
        answer: "Yes, Swift Dzire is available for airport pickup and drop services from Mumbai Airport."
    },
    {
        question: "Is Swift Dzire available for outstation travel?",
        answer: "Yes, customers can book Swift Dzire for outstation trips to Pune, Nashik, Shirdi, Goa, Mahabaleshwar, and many other destinations."
    },
    {
        question: "How many passengers can travel in a Swift Dzire?",
        answer: "Swift Dzire comfortably accommodates up to 4 passengers along with luggage."
    },
    {
        question: "Can corporate travelers book Swift Dzire rentals?",
        answer: "Yes, many business professionals and corporate clients choose Swift Dzire for meetings, airport transfers, and official travel."
    },
    {
        question: "Is the vehicle chauffeur-driven?",
        answer: "Yes, all Swift Dzire rentals from Mumbai Airport Cabs come with experienced and professional drivers."
    },
    {
        question: "Can I book Swift Dzire for full-day local travel?",
        answer: "Yes, full-day local travel packages are available for city tours, business visits, shopping trips, and personal travel."
    },
    {
        question: "Can I schedule the booking in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability on your preferred date and time."
    },
    {
        question: "Is Swift Dzire suitable for family travel?",
        answer: "Yes, Swift Dzire is a comfortable sedan option for small families, couples, and individual travelers."
    },
    {
        question: "How can I book Swift Dzire on Rent in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Joshi",
        feedback:
            "The Swift Dzire was clean, comfortable, and perfect for my airport transfer. The driver was punctual and the journey was smooth throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rina Kapoor",
        feedback:
            "We booked a Swift Dzire for a weekend trip and were very satisfied with the service. The vehicle was well-maintained and the travel experience was excellent.",
        rating: 5
    }
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Swift Dzire on Rent in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/swift-dzire-on-rent-mumbai.jpg",
"description": "Book Swift Dzire on rent in Mumbai for affordable and comfortable local travel, airport transfers, and outstation trips. Mumbai Airport Cabs offers well-maintained Dzire cars with professional drivers, transparent pricing, and flexible booking options for family and business travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/swift-dzire-on-rent-in-mumbai"
}
};







    return (
        <div>



<Helmet>
  <title>Swift Dzire on Rent in Mumbai | Dzire Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Swift Dzire on rent in Mumbai for local, airport, and outstation travel. Affordable Dzire cab service with professional drivers, clean cars, and flexible booking options."
/>

<meta
 name="keywords"
 content="swift dzire on rent in mumbai, mumbai swift dzire rental, swift dzire cab mumbai, rent swift dzire mumbai, swift dzire taxi mumbai, dzire car hire mumbai, swift dzire outstation cab mumbai, swift dzire airport cab mumbai, swift dzire family cab mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentinmumbai;